<template>
  <div class="section" data-section="navigation">
    <div class="box">
      <Logo></Logo>
      <Navigation :menuItems="menuItems"></Navigation>
      <RightBar></RightBar>
    </div>
  </div>
</template>

<script>
import RightBar from '@/components/Header/RightBar';
import Navigation from '@/components/Header/Navigation';
import Logo from '@/components/Header/Logo';

export default {
  name: 'NavigationSection',
  components: { Logo, Navigation, RightBar },
  computed: {
    menuItems() {
      return [
        {
          id: 'signup',
          name: this.$t('nav.registration'),
          description: this.$t('nav.registration_desc'),
          router: {
            name: 'Signup',
          },
          imgSrc: require('@/assets/images/navigation/ico-1.webp'),
          alt: this.$t('nav.registration_desc'),
          isModal: true,
        },
        {
          id: 'files',
          name: this.$t('nav.download'),
          description: this.$t('nav.download_desc'),
          router: {
            name: 'Downloads',
          },
          imgSrc: require('@/assets/images/navigation/ico-2.webp'),
          alt: this.$t('nav.download_desc'),
          isModal: true,
        },
        // {
        //   id: "support",
        //   name: "Поддержка",
        //   description: "Сервисы",
        //   router: {
        //     name: "Support",
        //   },
        //   imgSrc: require("@/assets/images/navigation/ico-3.webp"),
        //   alt: "База знаний",
        //   isModal: true,
        // },
        {
          id: 'forum',
          name: this.$t('nav.forum'),
          description: this.$t('nav.forum_desc'),
          router: {},
          link: 'https://forum.la2dream.com/',
          imgSrc: require('@/assets/images/navigation/ico-4.webp'),
          alt: this.$t('nav.forum_desc'),
          isModal: false,
        },
        {
          id: 'server',
          name: this.$t('nav.wiki'),
          description: this.$t('nav.wiki_desc'),
          router: {
            name: 'Server',
            params: {
              id: this.$store.state.default_server,
            },
          },
          imgSrc: require('@/assets/images/navigation/ico-6.webp'),
          alt: this.$t('nav.wiki_desc'),
          isModal: true,
        },
        {
          id: 'shop',
          name: this.$t('nav.shop'),
          description: this.$t('nav.shop_desc'),
          router: {
            name: 'Shop',
          },
          imgSrc: require('@/assets/images/navigation/ico-5.webp'),
          alt: this.$t('nav.shop_desc'),
          isModal: true,
        },
      ];
    },
  },
};
</script>

<style scoped></style>
